"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReviewToggleWrapper = function ReviewToggleWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "modalVisible", _descriptor, _this);
      _initializerDefineProperty(_this, "selectedCardTypeIds", _descriptor2, _this);
      _initializerDefineProperty(_this, "originalCardTypeIds", _descriptor3, _this);
      _initializerDefineProperty(_this, "message", _descriptor4, _this);
      _initializerDefineProperty(_this, "reviewCardsByTranslation", _descriptor5, _this);
      // needed for times when multiple toggle buttons are on the same page
      _initializerDefineProperty(_this, "showCreateNewReviewDeck", _descriptor6, _this);
      _initializerDefineProperty(_this, "reviewDeckName", _descriptor7, _this);
      _initializerDefineProperty(_this, "toggledReview", _descriptor8, _this);
      _initializerDefineProperty(_this, "toggledReviewValue", _descriptor9, _this);
      _initializerDefineProperty(_this, "submittingReview", _descriptor10, _this);
      if (!_this.props.animate && !_this.props.reviewCards) {
        _this.getReviewCards();
      }
      if (!_state.AppUI.reviewDeckStore.hasIndexData && !_this.props.reviewDecks) {
        _this.getReviewDecks();
      }
      if (_this.props.reviewCards && (0, _utils.isPresent)(_this.reviewCards)) {
        _this.translation.setSelectedDeckId(_this.reviewCards[0].deckId);
        _this.translation.setOriginalDeckId(_this.reviewCards[0].deckId);
        _this.originalCardTypeIds = _this.reviewCards.map(function (item) {
          return item.cardTypeId;
        });
        _this.selectedCardTypeIds = _this.reviewCards.map(function (item) {
          return item.cardTypeId;
        });
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.word && prevProps.word && this.props.word.id !== prevProps.word.id) {
          this.toggledReview = false;
          this.toggledReviewValue = false;
          this.getReviewCards();
        } else if (prevProps.reviewCards !== this.props.reviewCards) {
          if (this.reviewCards[0]) {
            this.translation.setSelectedDeckId(this.reviewCards[0].deckId);
            this.translation.setOriginalDeckId(this.reviewCards[0].deckId);
            this.originalCardTypeIds = this.reviewCards.map(function (item) {
              return item.cardTypeId;
            });
            this.selectedCardTypeIds = this.reviewCards.map(function (item) {
              return item.cardTypeId;
            });
          } else {
            this.translation.setSelectedDeckId(null);
            this.translation.setOriginalDeckId(null);
            this.originalCardTypeIds = [];
            this.selectedCardTypeIds = [];
          }
        } else if (this.props.animate && !prevProps.showButton && this.props.showButton && !this.props.reviewCards) {
          this.getReviewCards();
        } else if (this.props.animate && prevProps.showButton && !this.props.showButton) {
          this.deleteCurrentReview();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if ((0, _utils.isPresent)(this.translation) && this.translation.clearDeckIds) {
          this.translation.clearDeckIds();
        }
        this.disposer && this.disposer();
      }
    }, {
      key: "selectedDeckId",
      get: function get() {
        var _this$translation;
        return (_this$translation = this.translation) === null || _this$translation === void 0 ? void 0 : _this$translation.selectedDeckId;
      }
    }, {
      key: "deckId",
      get: function get() {
        return this.selectedDeckId || this.deckFromCards || this.defaultDeckId;
      }
    }, {
      key: "deckFromCards",
      get: function get() {
        return _state.AppUI.cardStore.hasIndexData ? _state.AppUI.cardStore.indexData[0].deckId : null;
      }
    }, {
      key: "defaultDeckId",
      get: function get() {
        if (_state.AppUI.reviewDeckStore.hasIndexData) {
          if ((0, _utils.isPresent)(_state.AppUI.reviewDeckStore.indexData.find(function (item) {
            return item.defaultReviewDeck;
          }))) {
            return _state.AppUI.reviewDeckStore.indexData.find(function (item) {
              return item.defaultReviewDeck;
            }).id;
          } else {
            return _state.AppUI.reviewDeckStore.indexData[0].id;
          }
        }
        return null;
      }
    }, {
      key: "showSpinner",
      get: function get() {
        return _state.AppUI.cardStore.requestCounter > 1;
      }
    }, {
      key: "translationId",
      get: function get() {
        return (0, _utils.isPresent)(this.translation) ? this.translation.id : null;
      }
    }, {
      key: "translation",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.word)) {
          return this.props.word;
        } else if ((0, _utils.isPresent)(this.props.sentence)) {
          return this.props.sentence;
        }
      }
    }, {
      key: "animateScale",
      get: function get() {
        if (!this.props.animate) {
          return;
        }
        return this.props.showButton ? 1 : 0;
      }
    }, {
      key: "hasReviews",
      get: function get() {
        var _this$props$word;
        // return this.props.hasReviews || isPresent(this.reviewCards);
        if (this.props.hasReviews) {
          return true;
        }
        return this.toggledReview ? this.toggledReviewValue : ((_this$props$word = this.props.word) === null || _this$props$word === void 0 ? void 0 : _this$props$word.reviewing) || (0, _utils.isPresent)(this.reviewCards);
      }
    }, {
      key: "hasReviewCards",
      get: function get() {
        return (0, _utils.isPresent)(this.reviewCards);
      }
    }, {
      key: "enableUpdateReviews",
      get: function get() {
        return (0, _utils.isPresent)((0, _mobx.toJS)(this.selectedCardTypeIds)) && (this.updatedCardTypeIds || this.updatedDeckId);
      }
    }, {
      key: "enableCreateReviewDeck",
      get: function get() {
        return (0, _utils.isPresent)(this.reviewDeckName);
      }
    }, {
      key: "hiddenCardTypes",
      get: function get() {
        var _Constants$REVIEW_CAR, _Constants$REVIEW_CAR2, _Constants$REVIEW_CAR3;
        if (!this.props.word) return {};
        return {
          gender: ((_Constants$REVIEW_CAR = _constants.Constants.REVIEW_CARD_TYPES.find(function (i) {
            return i.slug === 'gender';
          })) === null || _Constants$REVIEW_CAR === void 0 ? void 0 : _Constants$REVIEW_CAR.id) && this.props.word.hideFromGenderTrainer,
          plural: ((_Constants$REVIEW_CAR2 = _constants.Constants.REVIEW_CARD_TYPES.find(function (i) {
            return i.slug === 'plural';
          })) === null || _Constants$REVIEW_CAR2 === void 0 ? void 0 : _Constants$REVIEW_CAR2.id) && (this.props.word.hideFromPluralTrainer || this.props.word.noPlural),
          conjugation: ((_Constants$REVIEW_CAR3 = _constants.Constants.REVIEW_CARD_TYPES.find(function (i) {
            return i.slug === 'conjugation';
          })) === null || _Constants$REVIEW_CAR3 === void 0 ? void 0 : _Constants$REVIEW_CAR3.id) && this.props.word.hideFromConjugationTrainer
        };
      }
    }, {
      key: "isCardTypeHidden",
      value: function isCardTypeHidden(cardTypeId) {
        var cardType = _constants.Constants.REVIEW_CARD_TYPES.find(function (i) {
          return i.id === cardTypeId;
        });
        if (!cardType || !this.props.word) return false;
        return this.hiddenCardTypes[cardType.slug] || false;
      }
    }, {
      key: "updatedDeckId",
      get: function get() {
        return (0, _utils.isPresent)(this.deckId) && this.originalDeckId !== this.deckId;
      }
    }, {
      key: "updatedCardTypeIds",
      get: function get() {
        return (0, _utils.isPresent)((0, _mobx.toJS)(this.originalCardTypeIds)) && this.originalCardTypeIds.join(',') !== this.selectedCardTypeIds.join(',');
      }
    }, {
      key: "title",
      get: function get() {
        if (this.props.word) {
          return "Add '".concat(this.props.word.targetText, "' to Reviews");
        }
        return 'Add to Reviews';
      }
    }, {
      key: "cardTypeOption",
      value: function cardTypeOption(slug) {
        var cardType = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
          return item.slug === slug;
        });
        return [cardType.id, cardType.name];
      }
    }, {
      key: "cardTypeOptions",
      get: function get() {
        var _this$props$card, _this$props$card2, _this$props$card3;
        var options;
        if (this.props.word) {
          var _Constants$WORD_TYPES, _Constants$WORD_TYPES2;
          options = [this.cardTypeOption('vocab_word_translate'), this.cardTypeOption('vocab_word_comprehend')];
          if (this.wordTypeId === ((_Constants$WORD_TYPES = _constants.Constants.WORD_TYPES.find(function (item) {
            return item.name === 'Noun';
          })) === null || _Constants$WORD_TYPES === void 0 ? void 0 : _Constants$WORD_TYPES.id)) {
            var _this$props$word2;
            if (!this.props.word.hideFromGenderTrainer) {
              options.push(this.cardTypeOption('gender'));
            }
            if (((_this$props$word2 = this.props.word) === null || _this$props$word2 === void 0 ? void 0 : _this$props$word2.languageId) === 'DE') {
              options.push(this.cardTypeOption('plural'));
            }
          } else if (this.wordTypeId === ((_Constants$WORD_TYPES2 = _constants.Constants.WORD_TYPES.find(function (item) {
            return item.name === 'Verb';
          })) === null || _Constants$WORD_TYPES2 === void 0 ? void 0 : _Constants$WORD_TYPES2.id)) {
            options.push(this.cardTypeOption('conjugation'));
          }
        } else if (((_this$props$card = this.props.card) === null || _this$props$card === void 0 || (_this$props$card = _this$props$card.cardType) === null || _this$props$card === void 0 ? void 0 : _this$props$card.slug) === 'vocab_sentence_comprehend') {
          options = [this.cardTypeOption('vocab_sentence_comprehend'), this.cardTypeOption('translate'), this.cardTypeOption('comprehend')];
        } else if (((_this$props$card2 = this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.cardType) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.slug) === 'vocab_sentence_translate') {
          options = [this.cardTypeOption('vocab_sentence_translate'), this.cardTypeOption('vocab_sentence_comprehend'), this.cardTypeOption('translate'), this.cardTypeOption('comprehend')];
        } else if (((_this$props$card3 = this.props.card) === null || _this$props$card3 === void 0 || (_this$props$card3 = _this$props$card3.cardType) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.slug) === 'trivia') {
          options = [this.cardTypeOption('trivia'), this.cardTypeOption('translate'), this.cardTypeOption('comprehend')];
          if (_state.AppUI.user.admin) {
            var _Constants$REVIEW_CAR4;
            options.push([(_Constants$REVIEW_CAR4 = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
              return item.slug === 'vocab_sentence_comprehend';
            })) === null || _Constants$REVIEW_CAR4 === void 0 ? void 0 : _Constants$REVIEW_CAR4.id, 'Sentence Comprehension [Admin]']);
          }
        } else {
          options = [this.cardTypeOption('translate'), this.cardTypeOption('comprehend')];
          if ((0, _utils.isPresent)(this.props.sentence)) {
            options.push(this.cardTypeOption('vocab_sentence_translate'));
          }
          if (_state.AppUI.user.admin) {
            var _Constants$REVIEW_CAR5;
            options.push([(_Constants$REVIEW_CAR5 = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
              return item.slug === 'vocab_sentence_comprehend';
            })) === null || _Constants$REVIEW_CAR5 === void 0 ? void 0 : _Constants$REVIEW_CAR5.id, 'Sentence Comprehension [Admin]']);
          }
        }
        return options;
      }
    }, {
      key: "wordTypeId",
      get: function get() {
        var _this$props$word$word;
        return this.props.word && (this.props.word.wordTypeId || ((_this$props$word$word = this.props.word.wordType) === null || _this$props$word$word === void 0 ? void 0 : _this$props$word$word.id));
      }
    }, {
      key: "reviewCards",
      get: function get() {
        var _this2 = this;
        if (this.props.reviewCards) {
          return this.props.reviewCards.filter(function (item) {
            return (0, _utils.isPresent)(_this2.props.word) && item.wordId === _this2.props.word.id || (0, _utils.isPresent)(_this2.props.sentence) && item.sentenceId === _this2.props.sentence.id;
          });
        } else if (this.props.word && this.props.word.id) {
          return this.reviewCardsByTranslation[this.props.word.id] || [];
        } else if ((0, _utils.isPresent)(this.props.exercise) && this.props.exercise.id) {
          return this.reviewCardsByTranslation[this.props.exercise.id] || [];
        } else if ((0, _utils.isPresent)(this.props.sentence) && this.props.sentence.id) {
          return this.reviewCardsByTranslation[this.props.sentence.id] || [];
        }
        return [];
      }
    }, {
      key: "originalDeckId",
      get: function get() {
        var _this$translation2;
        return (_this$translation2 = this.translation) === null || _this$translation2 === void 0 ? void 0 : _this$translation2.originalDeckId;
      }
    }, {
      key: "deleteCurrentReview",
      value: function deleteCurrentReview() {
        var _this3 = this;
        var card = this.reviewCards.find(function (item) {
          return item.cardTypeId === _this3.props.card.cardTypeId;
        });
        if (card) {
          _state.AppUI.cardStore.destroy({
            ids: {
              cardId: card.id
            }
          }, this.afterUpdate);
        }
      }
    }, {
      key: "onSetDeckId",
      value: function onSetDeckId(deckId) {
        this.translation.setSelectedDeckId(deckId);
      }
    }, {
      key: "onToggleCardTypeId",
      value: function onToggleCardTypeId(cardTypeId) {
        if (this.props.disableToggleButton) {
          return;
        }
        this.selectedCardTypeIds = (0, _lodash.xor)(this.selectedCardTypeIds, [cardTypeId]);
      }
    }, {
      key: "onSubmit",
      value: function onSubmit() {
        var _this4 = this;
        if (this.enableUpdateReviews) {
          this.toggledReviewValue = true;
          if (this.hasReviews) {
            if (this.selectedDeckId !== this.originalDeckId) {
              _state.AppUI.cardStore.batchUpdate({
                data: {
                  cardIds: this.reviewCards.map(function (item) {
                    return item.id;
                  }),
                  deckId: this.selectedDeckId
                }
              }, this.afterUpdate);
              if ((0, _utils.isPresent)(this.translation) && this.translation.setOriginalDeckId) {
                this.translation.setOriginalDeckId(this.deckId);
              }
            }
            var cardTypeChanges = (0, _lodash.xor)((0, _mobx.toJS)(this.originalCardTypeIds), (0, _mobx.toJS)(this.selectedCardTypeIds));
            cardTypeChanges.map(function (cardTypeId) {
              var _this4$reviewCards$fi;
              var cardId = (_this4$reviewCards$fi = _this4.reviewCards.find(function (item) {
                return item.cardTypeId === cardTypeId;
              })) === null || _this4$reviewCards$fi === void 0 ? void 0 : _this4$reviewCards$fi.id;
              if (cardId) {
                _state.AppUI.cardStore.destroy({
                  ids: {
                    cardId: cardId
                  }
                }, _this4.afterUpdate);
              } else {
                _this4.createCard({
                  cardTypeId: cardTypeId
                }, _this4.afterUpdate);
              }
              _this4.originalCardTypeIds = _this4.selectedCardTypeIds;
            });
          } else {
            this.createCard({
              cardTypeIds: this.selectedCardTypeIds
            }, this.afterCreate);
          }
        }
      }
    }, {
      key: "createCard",
      value: function createCard(params, callback) {
        var _this$props$word3, _this$props$word4, _this$props$sentence;
        var data = Object.assign(params, {
          deckId: this.deckId,
          userId: _state.AppUI.user.id,
          wordId: (0, _utils.isPresent)(this.props.word) && ((_this$props$word3 = this.props.word) === null || _this$props$word3 === void 0 ? void 0 : _this$props$word3.id),
          sentenceId: (0, _utils.isPresent)(this.props.sentence) && this.props.sentence.id,
          wordAssociationIds: this.props.wordAssociationIds,
          languageId: ((_this$props$word4 = this.props.word) === null || _this$props$word4 === void 0 ? void 0 : _this$props$word4.languageId) || ((_this$props$sentence = this.props.sentence) === null || _this$props$sentence === void 0 ? void 0 : _this$props$sentence.languageId),
          exerciseId: (0, _utils.isPresent)(this.props.exercise) && this.props.exercise.id
        });
        _state.AppUI.cardStore.create({
          data: data
        }, callback);
      }
    }, {
      key: "afterCreate",
      value: function afterCreate() {
        this.submittingReview = false;
        _state.AppUI.loadUser();
        this.getReviewCards();
        this.message = 'A review has been updated';
      }
    }, {
      key: "afterUpdate",
      value: function afterUpdate() {
        this.submittingReview = false;
        _state.AppUI.loadUser();
        this.getReviewCards();
        this.message = 'A review has been created';
      }
    }, {
      key: "setModalVisible",
      value: function setModalVisible(modalVisible) {
        if (!modalVisible) {
          this.message = null;
        }
        if (!modalVisible && _state.AppUI.layout.isNative) {
          _state.AppUI.designateUiElementAsSeen('review-options-long-press');
        }
        _state.DeckUI.set('hideCardIcons', modalVisible);
        this.modalVisible = modalVisible;
      }
    }, {
      key: "onToggleCreateReview",
      value: function onToggleCreateReview() {
        var _this5 = this;
        var slug;
        this.toggledReview = true;
        if (this.hasReviewCards) {
          this.toggledReviewValue = false;
          this.reviewCards.map(function (item) {
            _state.AppUI.cardStore.destroy({
              ids: {
                cardId: item.id
              }
            }, _this5.getReviewCards);
          });
        } else if (!this.submittingReview) {
          var _this$props$card4, _this$props$sentence2, _this$props$word5;
          this.submittingReview = true;
          this.toggledReviewValue = true;
          if ((0, _utils.isPresent)(this.props.sentence)) {
            slug = 'translate';
          } else if ((_this$props$card4 = this.props.card) !== null && _this$props$card4 !== void 0 && _this$props$card4.conjugationCard) {
            slug = 'conjugation';
          } else {
            slug = 'vocab_word_translate';
          }
          if (this.props.card) {
            this.selectedCardTypeIds = [this.props.card.cardType.id];
          } else {
            var _Constants$REVIEW_CAR6;
            this.selectedCardTypeIds = [(_Constants$REVIEW_CAR6 = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
              return item.slug === slug;
            })) === null || _Constants$REVIEW_CAR6 === void 0 ? void 0 : _Constants$REVIEW_CAR6.id];
          }
          var data = {
            interface_source: this.props.interfaceSource,
            card_type_slug: (0, _utils.isPresent)(this.props.card) ? null : slug,
            card_type_id: (0, _utils.isPresent)(this.props.card) ? this.props.card.cardType.id : null,
            deck_id: this.deckId,
            user_id: _state.AppUI.user.id,
            word_id: this.props.word && this.props.word.id,
            sentence_id: (0, _utils.isPresent)(this.props.sentence) && this.props.sentence.id,
            language_id: (0, _utils.isPresent)(this.props.sentence) ? (_this$props$sentence2 = this.props.sentence) === null || _this$props$sentence2 === void 0 ? void 0 : _this$props$sentence2.languageId : (_this$props$word5 = this.props.word) === null || _this$props$word5 === void 0 ? void 0 : _this$props$word5.languageId
          };
          _state.AppUI.cardStore.create({
            data: data
          }, this.afterCreateReview);
        }
      }
    }, {
      key: "afterCreateReview",
      value: function afterCreateReview() {
        this.submittingReview = false;
        this.getReviewCards();
      }
    }, {
      key: "getReviewCards",
      value: function getReviewCards() {
        if (this.props.getReviewCards) {
          this.props.getReviewCards();
        } else {
          _state.AppUI.set('reloadReviewDecks', true); // for mobile
          _state.AppUI.cardStore.getIndex({
            queryStrings: {
              my_reviews: true
            },
            filters: {
              user_id: _state.AppUI.user.id,
              word_id: (0, _utils.isBlank)(this.props.sentence) && (0, _utils.isPresent)(this.props.word) && this.props.word.id,
              sentence_id: (0, _utils.isPresent)(this.props.sentence) && this.props.sentence.id,
              exercise_id: (0, _utils.isPresent)(this.props.exercise) && this.props.exercise.id
            }
          }, this.afterGetReviews);
        }
      }
    }, {
      key: "afterGetReviews",
      value: function afterGetReviews(resp) {
        _state.AppUI.cardStore.setIndexData(resp);
        if (this.props.word && this.props.word.id) {
          this.reviewCardsByTranslation[this.props.word.id] = _state.AppUI.cardStore.indexData;
        } else if ((0, _utils.isPresent)(this.props.sentence) && this.props.sentence.id) {
          this.reviewCardsByTranslation[this.props.sentence.id] = _state.AppUI.cardStore.indexData;
        } else if ((0, _utils.isPresent)(this.props.exercise) && this.props.exercise.id) {
          this.reviewCardsByTranslation[this.props.exercise.id] = _state.AppUI.cardStore.indexData;
        }
        var deckId = (0, _utils.isPresent)(this.reviewCards) && this.reviewCards.length > 0 ? this.reviewCards[0].deckId : null;
        if ((0, _utils.isPresent)(this.translation) && this.translation.setOriginalDeckId) {
          this.translation.setOriginalDeckId(deckId);
        }
        this.originalCardTypeIds = this.reviewCards.map(function (item) {
          return item.cardTypeId;
        });
        this.selectedCardTypeIds = this.reviewCards.map(function (item) {
          return item.cardTypeId;
        });
      }
    }, {
      key: "getReviewDecks",
      value: function getReviewDecks() {
        _state.AppUI.reviewDeckStore.getIndex();
      }
    }, {
      key: "toggleShowCreateNewReviewDeck",
      value: function toggleShowCreateNewReviewDeck() {
        this.showCreateNewReviewDeck = !this.showCreateNewReviewDeck;
      }
    }, {
      key: "onSetReviewDeckName",
      value: function onSetReviewDeckName(reviewDeckName) {
        this.reviewDeckName = reviewDeckName;
      }
    }, {
      key: "onCreateReviewDeck",
      value: function onCreateReviewDeck() {
        var data = {
          userId: _state.AppUI.user.id,
          deckType: 'review',
          name: this.reviewDeckName,
          color: 'blue'
        };
        _state.AppUI.deckStore.create({
          data: data
        }, this.afterCreateReviewDeck);
      }
    }, {
      key: "afterCreateReviewDeck",
      value: function afterCreateReviewDeck() {
        var _this6 = this;
        this.getReviewDecks();
        this.reviewDeckName = '';
        this.showCreateNewReviewDeck = false;
        this.message = 'New Review Deck Created';
        setTimeout(function () {
          return _this6.message = null;
        }, 3000);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          translation: this.translation,
          modalVisible: this.modalVisible,
          setModalVisible: this.setModalVisible,
          onToggleCreateReview: this.onToggleCreateReview,
          hasReviews: this.hasReviews,
          reviewCards: this.reviewCards,
          showSpinner: this.showSpinner,
          reviewDeckOptions: _state.AppUI.reviewDeckOptions,
          onSetDeckId: this.onSetDeckId,
          title: this.title,
          deckId: this.deckId,
          cardTypeOptions: this.cardTypeOptions,
          onToggleCardTypeId: this.onToggleCardTypeId,
          selectedCardTypeIds: this.selectedCardTypeIds,
          onSubmit: this.onSubmit,
          message: this.message,
          enableUpdateReviews: this.enableUpdateReviews,
          enableCreateReviewDeck: this.enableCreateReviewDeck,
          animateScale: this.animateScale,
          showCreateNewReviewDeck: this.showCreateNewReviewDeck,
          toggleShowCreateNewReviewDeck: this.toggleShowCreateNewReviewDeck,
          reviewDeckName: this.reviewDeckName,
          onSetReviewDeckName: this.onSetReviewDeckName,
          onCreateReviewDeck: this.onCreateReviewDeck,
          hiddenMessage: this.hiddenMessage,
          isCardTypeHidden: this.isCardTypeHidden
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "modalVisible", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selectedCardTypeIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "originalCardTypeIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "reviewCardsByTranslation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showCreateNewReviewDeck", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "reviewDeckName", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "toggledReview", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "toggledReviewValue", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "submittingReview", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "selectedDeckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckFromCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckFromCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "defaultDeckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "translationId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "translationId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "translation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "translation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "animateScale", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "animateScale"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasReviews", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasReviewCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasReviewCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "enableUpdateReviews", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "enableUpdateReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "enableCreateReviewDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "enableCreateReviewDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hiddenCardTypes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hiddenCardTypes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isCardTypeHidden", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "isCardTypeHidden"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updatedDeckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "updatedDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updatedCardTypeIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "updatedCardTypeIds"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "title", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "title"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeOption", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeOption"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "originalDeckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "originalDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deleteCurrentReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "deleteCurrentReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetDeckId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleCardTypeId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleCardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSubmit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "createCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCreate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCreate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterUpdate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterUpdate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setModalVisible", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setModalVisible"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleCreateReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleCreateReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCreateReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCreateReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getReviewCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getReviewCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getReviewDecks", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getReviewDecks"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleShowCreateNewReviewDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleShowCreateNewReviewDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetReviewDeckName", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetReviewDeckName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCreateReviewDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCreateReviewDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCreateReviewDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCreateReviewDeck"), _class2.prototype), _class2)) || _class;
};
ReviewToggleWrapper.displayName = 'ReviewToggleWrapper';
var _default = exports["default"] = ReviewToggleWrapper;